// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewStatus-Status_cls1__Bn9GV","cls2":"PaymentViewStatus-Status_cls2__Pw-Fv PaymentViewStatus-Status_cls1__Bn9GV","margins":"PaymentViewStatus-Status_margins__gsERa"};